import { Box, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Switch } from "@mui/material";
import { Button, Heading, MenuButton, Modal } from "../../components/Common";
import { NoRecordFound, Pagination, TableLoader } from "../../components/Common/Table";
import { MdMoreVert } from "react-icons/md";
import { useState } from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { HiOutlineTrash } from "react-icons/hi";
import { AiOutlineEdit } from "react-icons/ai";
import { useDeleteDiscountMutation, useGetDiscountListQuery, useStatusChangeDiscountMutation } from "../../services/Discount";
import { useMessage } from "../../components/Common/Message/MessageContext";

export default function Discounts() {
    const [page, setPage] = useState(0)
    const [isModalOpen, setIsModalOpen] = useState({ open: false, currentComponent: "", head: '', para: '', isEdit: false, id: "", data: null, delete: '' });
    const { data, error, isLoading } = useGetDiscountListQuery({ page: page + 1 });
    const [deleteDiscount] = useDeleteDiscountMutation()
    const [statusChangeDiscount] = useStatusChangeDiscountMutation();
    const { showMessage } = useMessage();
    const discountList = data?.data;

    const handleStatusChange = async (id, currentStatus) => {
        try {
            const response = await statusChangeDiscount({ id, status: !currentStatus });
            if (response?.data?.status) {
                showMessage('success', response?.data?.message);
            } else {
                showMessage('error', response?.data?.message || 'Failed to update status');
            }
        } catch (error) {
            showMessage('error', 'An error occurred while updating status');
        }
    };

    return (
        <>
            <Stack>
                <Stack my={1} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
                    <Heading head={'Discounts'} />
                    <Button buttonName='Add Discount' onClick={() => setIsModalOpen({ open: true, currentComponent: "addDiscount", isEdit: false })} />
                </Stack>
            </Stack>
            <TableContainer component={Paper}>
                <Table stickyHeader aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Coupon</TableCell>
                            <TableCell>Discount %</TableCell>
                            <TableCell>Categories</TableCell>
                            <TableCell>City</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isLoading ? (<TableLoader colspan='5' />) :
                            discountList && discountList.length > 0 ?
                                (discountList?.map((ele, i) => {
                                    return (
                                        <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 }, cursor: 'pointer' }}>
                                            <TableCell>{i + 1}</TableCell>
                                            <TableCell>{ele?.couponCode}</TableCell>
                                            <TableCell>{ele?.discountPercentage}%</TableCell>
                                            <TableCell>{Array.isArray(ele?.categories) ? ele.categories.map(cat => cat.serviceName || cat.name).join(', ') : ele?.categories}</TableCell>
                                            <TableCell>{ele?.city?.city || ele?.city || '-'}</TableCell>
                                            <TableCell onClick={(e) => e.stopPropagation()}>
                                                <Switch
                                                    checked={ele?.status === 1 || ele?.status === true}
                                                    onChange={() => handleStatusChange(ele?.id, ele?.status)}
                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                />
                                            </TableCell>
                                            <TableCell onClick={(e) => e.stopPropagation()}>
                                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                    <DropdownMenu.Root>
                                                        <DropdownMenu.Trigger className='dropDown'>
                                                            <MenuButton icon={<MdMoreVert style={{ color: '#000', fontSize: '18px' }} />} width='30px' height='33px' />
                                                        </DropdownMenu.Trigger>
                                                        <DropdownMenu.Content className='dropDownContent' align='end'>
                                                            <DropdownMenu.Item className='dropDownMenu' onClick={() => setIsModalOpen({ open: true, currentComponent: "addDiscount", isEdit: true, id: ele?.id, data: ele })}>
                                                                <Stack flexDirection={'row'} gap={1} alignItems={'center'}><AiOutlineEdit style={{ fontSize: '15px' }} /><Box sx={{ fontSize: '13px' }}>Edit</Box></Stack>
                                                            </DropdownMenu.Item>
                                                            <DropdownMenu.Item className='dropDownMenu' onClick={() => setIsModalOpen({ open: true, currentComponent: "actionModal", head: "Delete Discount", para: "Are you sure you want to delete this discount?", id: ele?.id, delete: deleteDiscount })}>
                                                                <Stack flexDirection={'row'} gap={1} alignItems={'center'}><HiOutlineTrash style={{ fontSize: '15px' }} /><Box sx={{ fontSize: '13px' }}>Delete</Box></Stack>
                                                            </DropdownMenu.Item>
                                                        </DropdownMenu.Content>
                                                    </DropdownMenu.Root>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }))
                                : <NoRecordFound colspan='5' />
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            {discountList && discountList.length > 0 ? <Pagination totalData={data?.total || 0} page={page} setPage={setPage} rowsPerPage={10} /> : ''}
            <Modal
                modalOpen={isModalOpen}
                handleClose={() => setIsModalOpen({ open: false, currentComponent: "", head: '', para: '', isEdit: false, id: "", data: null, delete: '' })}
            />
        </>
    );
}
